'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Question(question, answer) {
  this.hO = null;
  this.hN = null;
  this.hO = question;
  this.hN = answer;
}
export { $c_Lio_intela_sites_intelacloud_content_Question as $c_Lio_intela_sites_intelacloud_content_Question };
$p = $c_Lio_intela_sites_intelacloud_content_Question.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Question;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Question() {
}
export { $h_Lio_intela_sites_intelacloud_content_Question as $h_Lio_intela_sites_intelacloud_content_Question };
$h_Lio_intela_sites_intelacloud_content_Question.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 1465040773, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Question) && ((this.hO === x$0.hO) && (this.hN === x$0.hN))));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Question";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.hO;
  }
  if ((n === 1)) {
    return this.hN;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Question(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bE)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Question as $isArrayOf_Lio_intela_sites_intelacloud_content_Question };
var $d_Lio_intela_sites_intelacloud_content_Question = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Question, "io.intela.sites.intelacloud.content.Question", ({
  bE: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Question as $d_Lio_intela_sites_intelacloud_content_Question };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Question.js.map
